let env = {
  baseURL: "https://backend.maharttafl.net/api/",
};
export default env;
